import { render, staticRenderFns } from "./ValSectoresEdit.vue?vue&type=template&id=a7c84ca8&"
import script from "./ValSectoresEdit.vue?vue&type=script&lang=js&"
export * from "./ValSectoresEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports